export default __webpack_public_path__ + "static/B0213-7e0dbf60ceb97670abf63a5c6ed313f6.png";